'use strict';

module.exports = function () {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-util/lib/can-use-dom.js
// module id = 142
// module chunks = 0 1